"use client";

import BoxUi from '@components/common/BoxUi'
import LineBreaker from '@components/common/LineBreaker';
import TitleUi from '@components/common/TitleUi';
import CmsLayout from '@layouts/CmsLayout'
import AppBar from '@layouts/CmsLayout/Menu/AppBar/Index';
import MenuBar from '@layouts/CmsLayout/Menu/MenuBar';
import MenuDrawer from '@layouts/CmsLayout/Menu/MenuDrawer';
import { CSS_HELPERS, MEDIA_SCREENS, THEME_COLORS } from '@theme/constants';
import { Col, Row } from 'antd';
import Head from 'next/head';
import Image from 'next/legacy/image';
import React from 'react'
import ReactMarkdown from 'react-markdown';
import styled from 'styled-components';

export default function maintenance() {
    return (
        <CmsLayout>
            <View>
                <BoxUi>
                    <Row gutter={[30, 15]}>
                        <Col xs={24} sm={12} >
                            <div className="picContainer">
                                {/* <img 
                                className="pic" 
                                src="/figuras/maintenance.jpg" 
                                alt="Genesis" 
                                /> */}
                                <Image
                                    alt='Genesis'
                                    src={`/figuras/maintenance.jpg`}
                                    className='pic'
                                    layout="responsive"
                                    objectFit="cover"
                                    quality={100}
                                    unoptimized={true}
                                />
                                <div className="picOverlay" />
                            </div>
                        </Col>
                        <Col xs={24} sm={10}  >
                            <Row gutter={[15, 15]} style={{ background: '', height: '100%' }} >
                                <Col xs={24}>
                                    <Row gutter={[15, 15]}>
                                        <Col xs={24}>
                                            <TitleUi
                                                titulo={'Sección en manteniento'}
                                                noMarginX
                                                variant={'color_box'}
                                            />
                                        </Col>
                                        <Col xs={24} >
                                            <ReactMarkdown
                                                className='markdown-entradas'
                                            >
                                                {`Lo sentimos, está sección está en mantenimiento, pronto estará disponible.`}
                                            </ReactMarkdown>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>


                    </Row>
                </BoxUi>
            </View>
        </CmsLayout>
    );
}


///:: CARACTERISTICAS

const View = styled.div`
 
    .titulo_box {
        display: flex;
        h2{
            overflow: hidden;
            border-radius: ${CSS_HELPERS.RADIUS};
            border-top-right-radius: 200px;
            color:${THEME_COLORS.light.primary.contrastText};
            background-color:${THEME_COLORS.light.primary.alt};
            padding: .3em;
            padding-right: 3em;
           ${CSS_HELPERS.BORDER_LINE_BOTTOM}
        }
    };

    .categoria_descripcion_box{
        height: 15em;
        padding: 1em 0;
    }

    .picContainer{
        border-radius: 0 20pt 20pt 0;
        height: 33em;
        overflow: hidden;
        position:relative ;
        @media screen and  (min-width: ${0}px) and (max-width: ${MEDIA_SCREENS.XS}px) { 
        width:100%;
        }
        @media screen and  (min-width: ${MEDIA_SCREENS.XS}px) and (max-width: ${MEDIA_SCREENS.SM}px) { 
        width:100%;
        }
        @media screen and  (min-width: ${MEDIA_SCREENS.SM}px) and (max-width: ${MEDIA_SCREENS.MD}px) { 
        width:100%;
        }
        @media screen and  (min-width: ${MEDIA_SCREENS.MD}px) and (max-width: ${MEDIA_SCREENS.LG}px) { 
        width:100%;
        }
        .picOverlay{
            width:100% ;
            height: 33em;
            position:absolute;
            z-index:3;
            top:0;
            /* background: linear-gradient(90deg, #FFFFFF85 12%, #FFFFFF00 60%); */
            border-bottom: .6em solid ${THEME_COLORS.light.secondary.main};
            border-radius:0 20pt 20pt 0;

        }
        .pic{
            object-fit:cover;
            width:100%; 
            border-radius:0 20pt 20pt 0 ;
            overflow:hidden ;
            max-width:100%;
            width:100%;
            height:100%;
        }


    }
`